import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/logo.png'


const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "app-header-logo" }, [
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createElementVNode("img", {
      style: {"width":"60px","height":"50px","float":"left"},
      src: _imports_0
    }),
    /*#__PURE__*/_createElementVNode("span", { style: {"float":"left","display":"inline-block","line-height":"60px"} }, "账户管理")
  ])
], -1)
const _hoisted_3 = { class: "right-panel" }
const _hoisted_4 = { class: "el-dropdown-link user-link" }
const _hoisted_5 = { class: "user-name" }

import {inject, onMounted, ref} from 'vue'
import {Lock, Bell, Refresh, User, SwitchButton, ArrowDown} from "@element-plus/icons-vue";
import R from "@/utils/r";
import UserService from "@/api/user";
import {useRouter} from "vue-router";
import NativeService from "@/api/native";
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  emits: ["lockEvent"],
  setup(__props, { emit: __emit }) {

let emit = __emit;

// 获取路由实例
const router = useRouter();
// 使用 inject 函数注入 userService 实例
const userService = inject('userService') as UserService;
const nativeService = inject('nativeService') as NativeService;
let user = ref({})

const logoutAction = () => {
  userService.logout().then((data: any) => {
    if (R.isSuccess(data)) {
      // localStorage.removeItem("token");
      router.push("/login")
    }
  });
}


const area = ref({});
const weather = ref({});
const getWeather = () => {
  nativeService.getArea().then((data: any) => {
    if (data.status == 1) {
      area.value = data;
      nativeService.getWeather({city:data.adcode}).then((data: any) => {
        if (data.status == 1) {
          weather.value = data.lives[0];
        }
      });
    }
  });
}


// 在组件挂载后获取数据
onMounted(async () => {
  // 调用服务端接口获取用户数据
  const initData = () => {
    userService.getPrincipal().then((data: any) => {
      if (R.isSuccess(data)) {
        user.value = data.t;
        if (data.t.isLock == 1) {
          lockEvent();
        }
      }
    });
  }

  initData();
  getWeather();
});

const lockEvent = () => {
  emit('lockEvent');
}

const goToProfilePage = () => {
  router.push("/profile")
}

const refreshAction = () => {
  window.location.reload();
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tag, {
              type: "success",
              size: "large",
              style: {"margin":"12px 10px 0 15px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(area.value.province) + "-" + _toDisplayString(area.value.city), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tag, {
              type: "primary",
              size: "large",
              style: {"margin-top":"12px","margin-right":"10px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("天气：" + _toDisplayString(weather.value.weather) + "   气温：" + _toDisplayString(weather.value.temperature) + "°   风向描述：" + _toDisplayString(weather.value.winddirection) + _toDisplayString(weather.value.windpower) + "级 ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tag, {
              type: "info",
              size: "large",
              style: {"margin-top":"12px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("报告时间：" + _toDisplayString(weather.value.reporttime), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_icon, {
                class: "lock",
                onClick: lockEvent
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Lock))
                ]),
                _: 1
              }),
              _createVNode(_component_el_icon, {
                class: "refresh",
                onClick: refreshAction
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Refresh))
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown, null, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        icon: _unref(User),
                        onClick: goToProfilePage
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("个人中心")
                        ]),
                        _: 1
                      }, 8, ["icon"]),
                      _createVNode(_component_el_dropdown_item, {
                        icon: _unref(SwitchButton),
                        onClick: logoutAction
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 退出登陆 ")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, [
                    _createVNode(_component_el_avatar, {
                      class: "user-avatar",
                      src: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                    }),
                    _createElementVNode("div", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_unref(user).nickName), 1),
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ArrowDown))
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})